import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Dashboard = () => {

    //state user
    const [user, setUser] = useState({});
    const [profileList, SetProfileList] = useState([]);
    const urlImg = "https://dev.jftheskinspecialist.com/images/product/";

    //define navigate
    const navigate = useNavigate();

    //token
    const token = localStorage.getItem("token");

    //function "fetchData"
    const fetchData = async () => {

        //set axios header dengan type Authorization + Bearer token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            //fetch user from Rest API
        await axios.get('https://dev.jftheskinspecialist.com/api/user')
        .then((response) => {
                //set response user to state
                setUser(response.data);
            //console.log(response.data);
            fetch(`https://dev.jftheskinspecialist.com/api/userprofil/${response.data.id}`)
            .then((res) => {
                return res.json()
            })
            .then((datas) => {
                console.log(datas.data);
                SetProfileList(datas.data);
            });
        })
        .catch((error) => {
            //alert('error', error.response)
            //dispatch(userUpdateProfileFail())
            localStorage.removeItem("token");
            navigate('/login');
        })
    }

    //hook useEffect
    useEffect(() => {

        //check token empty
        if (!token) {

            //redirect login page
            navigate('/login');
        }

        //call function "fetchData"
        fetchData();
    }, []);

    //function logout
    const logoutHanlder = async () => {

        //set axios header dengan type Authorization + Bearer token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        //fetch Rest API
        await axios.post('https://dev.jftheskinspecialist.com/api/logout')
            .then(() => {

                //remove token from localStorage
                localStorage.removeItem("token");
                localStorage.removeItem("user_loginset");
                localStorage.removeItem("user_emailset");

                //redirect halaman login
                navigate('/login');
                window.location.reload();
            });
    };
    
    return (
        <div className="max-w-12xl p-4 mx-auto">
            <div class="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
                <div class="flex items-center">
                    {/*<img src="https://via.placeholder.com/150" alt="Profile Picture" class="w-32 h-32 rounded-full border-2 border-gray-300" />*/}
                        <div class="ml-6">
                        <h2 class="text-2xl font-bold text-gray-800">{user.name} </h2>
                        <p class="text-gray-600">{user.email}</p>
                            {/*<p class="text-gray-500">john.doe@example.com</p>
                            <p class="text-gray-500">Location: San Francisco, CA</p>*/}
                        </div>
                </div>

               {/*<div class="mt-6">
                    <h3 class="text-xl font-semibold text-gray-800">About Me</h3>
                    <p class="text-gray-700 mt-2">I am a passionate software developer with a love for creating intuitive and dynamic user experiences. I enjoy working with the latest technologies and continuously learning new skills.</p>
                </div>*/}

                <div class="mt-6">
                    <h3 class="text-xl font-semibold text-gray-800">Rate & Review Product : </h3>
                    <ul class="mt-4 space-y-4" style={{ listStyleType: 'none' }}>
                        <li class="bg-gray-100 p-4 rounded-lg shadow">
                            <table class="table-auto w-full">
                                <thead class="text-xs font-semibold uppercase text-gray-400 bg-gray-50">
                                    <tr>
                                        <th class="p-2 whitespace-nowrap">
                                            <div class="font-semibold text-left">Product Name</div>
                                        </th>
                                        <th class="p-2 whitespace-nowrap">
                                            <div class="font-semibold text-left">Rating</div>
                                        </th>
                                        <th class="p-2 whitespace-nowrap">
                                            <div class="font-semibold text-left">Comment</div>
                                        </th>
                                        <th class="p-2 whitespace-nowrap">
                                            <div class="font-semibold text-center">Date</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="text-sm divide-y divide-gray-100">
                                {profileList.map((profil, index) => (
                                    <tr key={index}>
                                        <td class="p-2 whitespace-nowrap">
                                            <div class="flex items-center">
                                                <div class="w-10 h-10 flex-shrink-0 mr-2 sm:mr-3"><img class="rounded-full" src={urlImg + '' + profil.featured_image} width="40" height="40" alt={profil.product_name} /></div>
                                                <div class="font-medium text-gray-800">{profil.product_name}</div>
                                            </div>
                                        </td>
                                        <td class="p-2 whitespace-nowrap">
                                            <div class="text-left">{profil.rating}</div>
                                        </td>
                                        <td class="p-2 whitespace-nowrap">
                                            <div class="text-left font-medium text-green-500">{profil.comment}</div>
                                        </td>
                                        <td class="p-2 whitespace-nowrap">
                                            <div class="text-lg text-center">{profil.ratingDate}</div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </li>
                        <li class="bg-gray-100 p-4 rounded-lg shadow">
                            <button onClick={logoutHanlder} className="btn btn-md btn-danger">LOGOUT</button>
                        </li>
                       
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
